import { render, staticRenderFns } from "./BackgroundAudioCheck.vue?vue&type=template&id=67ef075a&scoped=true&"
import script from "./BackgroundAudioCheck.vue?vue&type=script&lang=ts&"
export * from "./BackgroundAudioCheck.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundAudioCheck.vue?vue&type=style&index=0&id=67ef075a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ef075a",
  null
  
)

export default component.exports